import {getIdToken} from "../../misc/miscUtils.ts";
import {URL_BASE} from "../../../Globals.ts";

export const addFilesToTracker = async (userObjRef: any, environmentObjRef: any, fileNames: string[]) => {
    // First check
    if (!userObjRef.current.user || !environmentObjRef.current.projectName) {
        // Wait 5 seconds and check again
        await new Promise(resolve => setTimeout(resolve, 5000));
        if (!userObjRef.current.user || !environmentObjRef.current.projectName) return;
    }

    if (!environmentObjRef.current.projectEmbeddingsLastUpdated) return;

    try {
        const token = await getIdToken(userObjRef.current.user);
        const url = `${URL_BASE}/api/addFilesToTracker`;

        await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                projectName: environmentObjRef.current.projectName,
                fileNames: fileNames
            })
        });
    } catch (error) {
        console.error(`Error adding file name to tracker: ${error}`);
    }
};